<template>
  <div style="height: 100%;background-color: #f7f8fa;">

    <van-tabs>
      <van-tab style="padding: 16px" :title="'可用 ' + okList.length">
        <van-list :finished="finished" finished-text="没有更多了 D">
          <van-cell v-for="(item, index) in okList" :key="index" style="margin-top: 8px;border-radius: 10px;">
            <div slot="default">
              <div class="card" style="display: flex">
                <div class="left">
                  <span class="kyye">可用余额</span>
                  <span class="jd">{{ item.type === 1 ? item.quantity / 100 : item.quantity }}
                    <span v-if="item.type === 1" style="font-size: 12px;  font-weight:normal;">豆</span>
                    <span v-if="item.type === 2" style="font-size: 12px;  font-weight:normal;">次</span>
                  </span>
                  <span class="kh">卡尾号{{ item.cardId.toString().padStart(6, '0') }}</span>
                </div>
                <div class="right"
                  @click="$router.replace({ path: 'card-detail', query: { cardId: item.cardId.toString() } })">
                  <span
                    style="display: block;font-size: 17px;font-weight: 400;margin-left: 20px;margin-top:12px;color: #333333">
                    {{ item.name }}
                  </span>
                  <span style="display: block;margin-left: 20px;margin-top: 16px;font-size: 12px;color: #999">
                    有效期至 {{ item.expireEnd | moment('YYYY-MM-DD HH:mm') }}
                  </span>
                  <span style="display: block;margin-left: 20px;font-size: 12px;color: #999">使用说明 ></span>
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>

        <van-button block class="login-btn" plain round style="margin-top: 16px" type="info"
          @click="goBindCard"> 绑定新卡券 </van-button>
      </van-tab>

      <van-tab style="padding: 16px" :title="'不可用 ' + banList.length">
        <van-list :finished="finished" finished-text="没有更多了 E">
          <van-cell v-for="(item, index) in banList" :key="index" style="margin-top: 8px;border-radius: 10px;">
            <div slot="default">
              <div class="card" style="display: flex">
                <div class="left" style="background: linear-gradient(270deg, #969696, #7A7A7A)">
                  <span class="kyye">可用余额</span>
                  <span class="jd">{{ item.type === 1 ? item.quantity / 100 : item.quantity }}
                    <span v-if="item.type === 1" style="font-size: 12px;  font-weight:normal;">豆</span>
                    <span v-if="item.type === 2" style="font-size: 12px;  font-weight:normal;">次</span>
                  </span>
                  <span class="kh">卡尾号 {{ item.cardId.toString().padStart(6, '0') }}</span>
                </div>
                <div class="right"
                  @click="$router.replace({ path: 'card-detail', query: { cardId: item.cardId.toString() } })">
                  <span
                    style="display: block;font-size: 17px;font-weight: 400;margin-left: 20px;margin-top:12px;color: #333333">
                    {{ item.name }}
                  </span>
                  <span style="display: block;margin-left: 20px;margin-top: 16px;font-size: 12px;color: #999">
                    有效期至 {{ item.expireEnd | moment('YYYY-MM-DD HH:mm') }}
                  </span>
                  <span style="display: block;margin-left: 20px;font-size: 12px;color: #999">使用说明 ></span>
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>

        <!-- 过期时间太久的 -->
        <div style="text-align: center;">
          <span v-for="e in banExpireList" :key="e">.</span>
        </div>
      </van-tab>
    </van-tabs>

    <!-- 如果是从活动页来的 点我可回到活动页 -->
    <BackToAct />
  </div>
</template>

<script>
import { mall_WxUser_getMyCards } from "../api/user"
import { mall_wx_get_user_info } from "@/api/login"

export default {
  name: "user-cards",

  created() {
    this._getMyCards_1_()
  },

  data() {
    return {
      okList: [],
      banList: [],
      banExpireList: [],
      finished: false
    };
  },

  methods: {
    // 卡是否可用
    is_card_useable(card) {
      const _now = this.$moment(new Date())
      var _diff = this.$moment(card.expireEnd).diff(_now, 'minutes')

      var useable = card.status === 1
        && card.quantity > 0
        && _diff >= 0

      return useable;
    },

    is_card_in_30_days(card) {
      const _now = this.$moment(new Date())
      var _diff = this.$moment(card.expireEnd).diff(_now, 'days')
      return _diff > -30
    },

    _getMyCards_1_() {
      mall_wx_get_user_info().then(() => {
        mall_WxUser_getMyCards().then(res => {
          this.okList = res.data.filter(d => this.is_card_useable(d)) // 可用的卡

          this.banList = res.data.filter((d) => !this.is_card_useable(d) && this.is_card_in_30_days(d)) // 不可用的卡 超过30天的不展示

          this.banExpireList = res.data.filter((d) => !this.is_card_useable(d) && !this.is_card_in_30_days(d)) // 不可用 且很久以前的
        })
      })
    },

    goBindCard() {
      budo_log.info("#122 go bind card")

      this.$router.replace('bind-card');
    },

    forbidBack() {
      window.history.pushState('forward', null, '#');
      window.history.forward(1);
    },
  }
}
</script>

<style scoped>
.card {
  height: 110px;
  border-radius: 5px;
}

.van-cell {
  padding: 0;
}

.card .left {
  width: 102px;
  height: 110px;
  background: linear-gradient(270deg, #EA433A, #ED6F56);
}

.kyye {
  height: 10px;
  font-size: 12px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 20px;
  left: 15px;
  top: 10px;
  display: block;
  position: absolute;
}

.jd {
  height: 16px;
  font-size: 20px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 20px;
  left: 15px;
  top: 43px;
  display: block;
  position: absolute;
}

.kh {
  width: 98px;
  height: 10px;
  font-size: 12px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 20px;
  left: 11px;
  top: 75px;
  display: block;
  position: absolute;
}

.right {
  height: 100px;
  left: 102px;
  display: block;
  position: absolute;
  color: #000;
  float: left;
}
</style>
